import React, { useEffect } from 'react';
import Hero from './Hero';
import StatsBar from './StatsBar';
import PipelineSection from './PipelineSection';
import FeatureTabs from './FeatureTabs';
import CTABanner from './CTABanner';
import Footer from '../../Footer';

const RealEstateCRMPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div style={{ fontFamily: "'Montserrat', Helvetica, Arial, sans-serif" }}>
      <Hero />
      <StatsBar />
      <PipelineSection />
      <FeatureTabs />
      <CTABanner />
      <Footer />
    </div>
  );
}

export default RealEstateCRMPage;
